import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// ==============================|| ROLE PROTECTED ROUTE ||============================== //

export default function RoleProtectedRoute({ children, allowedRoles, fallbackPath = '/dashboard/default' }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null; // or a loading spinner
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}
